export default {
  statusEdited: 'edited',
  statusError: 'error',
  statusReady: 'ready',
  statusLoading: 'loading',
  statusPublishing: 'publishing',
  statusSaving: 'saving',
  statusRemoving: 'removing'
}
